export default class Rate {
	currency: string;

	factor: string;

	constructor(currency: string, factor: string) {
		this.currency = currency;
		this.factor = factor;
	}

	factorUpdated(factor: string): Rate {
		return new Rate(this.currency, factor);
	}
}
